import { render, staticRenderFns } from "./editcomponent.vue?vue&type=template&id=3e139afe&scoped=true&"
import script from "./editcomponent.vue?vue&type=script&lang=js&"
export * from "./editcomponent.vue?vue&type=script&lang=js&"
import style0 from "./editcomponent.vue?vue&type=style&index=0&id=3e139afe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e139afe",
  null
  
)

export default component.exports